import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PIconModule } from '@panaya/ui/p-icon';
import { PSideBarCloseableComponent } from './p-side-bar-closeable.component';

@NgModule({
    declarations: [PSideBarCloseableComponent],
    imports: [CommonModule, PIconModule],
    exports: [PSideBarCloseableComponent]
})
export class PSideBarCloseableModule {}
